import React from 'react'
import PropTypes from 'prop-types'
import { Link as RouterLink } from '@reach/router'
import { Link as PPLink } from '@paypalcorp/pp-react'
import { serverData } from 'utils/server-data'
import { routerLinkCss } from './style'

function Link(props) {
  const { to = '/', toFullPath, onClick = () => {}, ...rest } = props
  if (toFullPath) {
    return <PPLink css={routerLinkCss} href={toFullPath} onClick={onClick} {...rest} />
  }

  return (
    <RouterLink
      css={routerLinkCss}
      to={`${serverData.requestURI}${to}`}
      onClick={onClick}
      {...rest}
      className="ppvx_link"
    />
  )
}

Link.propTypes = {
  to: PropTypes.string,
  toFullPath: PropTypes.string,
  onClick: PropTypes.func,
}

export default Link
